import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

import Button from 'material-ui/RaisedButton'
import FontAwesome from 'react-fontawesome'
import AgendaSelectList from 'components/AgendaSelectList'

class TopBar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showAgendaList: false
    }
    this.handleShowAgendas = this.handleShowAgendas.bind(this)
    this.handleAgendaSelect = this.handleAgendaSelect.bind(this)
  }

  handleShowAgendas(show) {
    this.setState({ showAgendaList: show })
  }
  handleAgendaSelect(agenda) {
    // Hide dialog
    this.handleShowAgendas(false)
    // Signal selected agenda
    const { onAgendaSelect } = this.props
    onAgendaSelect(agenda)
  }

  render() {
    const { agendas, onRefreshAgendas, onLogOut, ui } = this.props
    const { showAgendaList } = this.state

    return (
      <div className="TopBar">

        <div className="Content">

          <img src={require('./logo.png')} alt="logo" />

          {/* Agendas */}
          <div className="Controls">

            <Button label="Agendas"
              onClick={this.handleShowAgendas.bind(null, true)}
              icon={<FontAwesome name="book" />}
            />

            {/* Used here to keep state control simple */}
            <AgendaSelectList
              agendas={agendas}
              open={showAgendaList}
              onAgendaSelect={this.handleAgendaSelect}
              onRefreshAgendas={onRefreshAgendas}
              onClose={this.handleShowAgendas.bind(null, false)}
              ui={ui}
            />

            <span className="LogOut" onClick={onLogOut}>
              [Sair]
            </span>

          </div>

        </div>

      </div>
    )
  }

}
TopBar.propTypes = {
  agendas: PropTypes.array.isRequired,
  onAgendaSelect: PropTypes.func.isRequired,
  onRefreshAgendas: PropTypes.func.isRequired,
  onLogOut: PropTypes.func.isRequired,
  ui: PropTypes.object.isRequired,
}
export default TopBar



// WEBPACK FOOTER //
// ./src/components/TopBar/index.js